import { namespacer } from 'helpers'

const namespace = namespacer('MEMBERSHIP_TYPE')
export const MEMBERSHIP_TYPE_SUCCESS = namespace('MEMBERSHIP_TYPE_SUCCESS')
